import { render, staticRenderFns } from "./balanceInfo.vue?vue&type=template&id=06bf14d9&scoped=true&"
import script from "./balanceInfo.vue?vue&type=script&lang=js&"
export * from "./balanceInfo.vue?vue&type=script&lang=js&"
import style0 from "./balanceInfo.vue?vue&type=style&index=0&id=06bf14d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf14d9",
  null
  
)

export default component.exports